<!-- 调整条件弹框 -->
<template>
<div class='container'>
</div>
</template>

<script>

export default {
components: {},
data() {
return {

}
},
computed: {},
watch: {},
methods: {

},
created() {

},
mounted() {

},
}
</script>
<style lang='scss' scoped>
.container {

}

</style>